// extracted by mini-css-extract-plugin
export var chip = "_qj-0";
export var icon = "_qj-1";
export var remove = "_qj-2";
export var removeIcon = "_qj-3";